import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { userSessionState } from '/src/components/user'
import { getRequest } from '/src/httpClient'

export const useSession = (reset = false) => {
  const [results, setResults] = useRecoilState(userSessionState)

  useEffect(() => {
    if (results) return
    const controller = new AbortController();

    (async () => {
      const response = await getRequest('/api/user/session', controller)      
      setResults(response)
    })()

    return () => controller.abort()
  }, [reset])

  return results
}
